import { Stack } from 'expo-router';
import { NotFoundContent } from '@/components/ui/NotFoundContent';

export default function NotFoundScreen() {
  return (
    <>
      <Stack.Screen options={{ title: 'Oops!' }} />
      <NotFoundContent />
    </>
  );
}